import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useModalOpen } from '../../../hooks/useToastModalOpen';
import { useShallow } from 'zustand/shallow';
import useModalStore from '../../../zustand/store/useModalStore';
import ToastModal from '../../../component/common/modal/ToastModal';
import ConfirmModal from '../../../component/common/modal/ConfirmModal';
import { useIs17Inch } from '../../../hooks/useBreakPoint';

import '../../../css/join.css';
import * as Icons from '../../../images/icons/icons_component';
import * as Theme from '../../../images/icons/icons_theme';
import { ReactComponent as NoticeIco16 } from '../../../images/icons/icon_16/Notice_ico_16.svg'; // uploader 이슈

const FindPage = () => {

    const navigate = useNavigate();

    const [findTab, setFindTab] = useState('Id');
    const [findStep, setFindStep] = useState(1);

    const [newPwOn, setNewPwOn] = useState(false);
    const [reNewPwOn, setReNewPwOn] = useState(false);

    const initAuthInfo = {
        ci: '',
        di: '',
        diCheck: '',
        userMoblphon: '',
        userName: '',
        userId: ''
    };

    const [authenticated, setAuthenticated] = useState(false);
    const [userAuthInfo, setuserAuthInfo] = useState(initAuthInfo);

    const handleNiceAuth = async () => {
        const res = await axios.post('/commonapi/nice/main.do');
        const { encData } = res.data;

        // form 생성 후 전송 (팝업 방식)
        const form = document.createElement('form');
        form.setAttribute('name', 'form_chk');
        form.setAttribute('method', 'post');
        form.setAttribute('action', 'https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb');
        form.setAttribute('target', 'nicePopup');

        const input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', 'EncodeData');
        input.setAttribute('value', encData);
        form.appendChild(input);
        const input2 = document.createElement('input');
        input2.setAttribute('type', 'hidden');
        input2.setAttribute('name', 'm');
        input2.setAttribute('value', 'checkplusSerivce');
        form.appendChild(input2);
        document.body.appendChild(form);

        window.open('', 'nicePopup', 'width=400,height=600');
        form.submit();
    };

    useEffect(() => {
        const handler = (event) => {
            const data = event.data;
            if (data && data.di) {
                setAuthenticated(true);
                setuserAuthInfo(data);
                console.log('본인 인증 결과:', data);
                // 이후 처리 로직 작성
            }
        };

        window.addEventListener('message', handler);
        return () => {
            window.removeEventListener('message', handler);
        };
    }, []);

    // modal
    const [toastState, notiModal, confirmModal, showNotiModal] = useModalStore(
        useShallow((state) => [state.toastState, state.notiModal, state.confirmModal, state.showNotiModal]));

    // toast modal open function
    const { toastModalOpen } = useModalOpen();
    
    const pswdInit = {
        useridno : '',
        newpswd: '',
        renewpswd: ''
    }
    const [upNewPw, setUpNewPw] = useState(pswdInit);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const passNewParams = {
            ...upNewPw,
            [name]: value
        };
        setUpNewPw(passNewParams);
    };

    const handleTab = () => {
        if(findTab === 'Pw') {
            setFindTab('Id');
        } else {
            setFindTab('Pw');
        };
        setFindStep(1);
        setUpNewPw(pswdInit);
        setAuthenticated(false);
        setuserAuthInfo(initAuthInfo);
    };

    const handleFindPw = async () => {
        if(upNewPw.useridno === '') {
            showNotiModal('아이디를 입력해 주세요.');
            return false;
        };
        try {
            const response = await axios.post('/commonapi/member/selectIntgIdCheck.do',
                { userId: String(upNewPw.useridno) },
                {headers: {'Content-Type': 'application/json'}}
            )
            if (!response.data.isExist) {
                showNotiModal('입력하신 아이디를 찾을 수 없습니다.');
                return false;
            }
            setFindStep(2);
        } catch (error) {
            showNotiModal('아이디 확인 도중 오류가 발생하였습니다.');
        }
    };

    const passwordReset = async () => {
        if(upNewPw.useridno !== userAuthInfo.userId) {
            return false;
        }
        try {
            // 로그인 전 화면이라 로그인 검사 예외 경로(/commonapi/member/)의 전용 API 를 쓴다.
            // 서버는 바꿀 계정을 이 아이디가 아니라 방금 받은 본인인증 결과로 정하고, 이 아이디는 대조에만 쓴다.
            const response = await axios.post('/commonapi/member/resetPassword.do', {
                useridno: upNewPw.useridno,
                userpswd: upNewPw.newpswd, // 변경할 암호
            });
            const result = response.data.resultMap.result;
            const resultMessage = response.data.resultMap.resultMessage;

            if(result) {
                toastModalOpen(resultMessage);
                setFindStep(4);
            } else {
                showNotiModal(resultMessage);
            }
        
        } catch (error) {
            console.error('임시 비밀번호 발급 중 오류 발생:', error);
        }
    }
    
    useEffect(() => {
        if(findTab === 'Pw' && authenticated && upNewPw.useridno === userAuthInfo.userId) {
            setFindStep(3);
        };
        if(findTab === 'Id' && authenticated) {
            setFindStep(2);
        };
    }, [authenticated]);

    const handleLogin = () => {
        navigate('/member/login.do');
    };

    const handleJoin = () => {
        navigate('/member/joinPage.do');
    };

    const handleCancel = () => {
        if(findStep !== 1) {
            setFindStep(1);
            setUpNewPw(pswdInit);
        } else {
            navigate('/member/login.do');
        }
        setAuthenticated(false);
        setuserAuthInfo(initAuthInfo);
    };

    const getByteLength = (text) => {
        let byteLength = 0;
        for (let i = 0; i < text.length; i++) {
            const charCode = text.charCodeAt(i);
            if (charCode <= 0x007f) {
                byteLength += 1; // ASCII 문자
            } else if (charCode <= 0x07ff) {
                byteLength += 2; // 라틴, 일부 기호
            } else {
                byteLength += 2; // 대부분의 한글, 한자, 기타
            }
        }
        return byteLength;
    };
    
    // 글자수(byte) 체크
    const getByte = getByteLength(upNewPw.newpswd);
    const newpswdByte = getByte < 257;

    // 문자 조합 정규식
    const passwordReg1 = /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{9,}$/;
    const passwordReg2 = /^(?=.*?[a-zA-Z])(?=.*?[0-9]).{10,}$/;
    const passwordReg3 = /^(?=.*?[a-zA-Z])(?=.*?[#?!@$%^&*-]).{10,}$/;
    const passwordReg4 = /^(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{10,}$/;

    // 문자 2조합, 최소 10자리 / 문자 3조합, 최소 9자리 체크
    const newpswdValid = passwordReg1.test(upNewPw.newpswd) || passwordReg2.test(upNewPw.newpswd) || passwordReg3.test(upNewPw.newpswd) || passwordReg4.test(upNewPw.newpswd);
    // 재입력 비밀번호 일치여부
    const sameNewpswd = upNewPw.newpswd === upNewPw.renewpswd;
    // 유효성 검사 완료 후 버튼 활성화
    const isValidCheckN = !newpswdByte || !newpswdValid || !sameNewpswd;

    const is17Inch = useIs17Inch();

    return (
        <div className='main_container'>
            {!toastState ? '' : <ToastModal/> }
            <div className='join_container'>
                <div className='flex flex-col gap-5'>
                    <input type='hidden' id='userName' name='userName' value={userAuthInfo.userName} />
                    <input type='hidden' id='ipinDi' name='ipinDi' value={userAuthInfo.di} />
                    <input type='hidden' id='ipinCi' name='ipinCi' value={userAuthInfo.ci} />
                    <input type='hidden' id='userMoblphon' name='userMoblphon' value={userAuthInfo.userMoblphon} />
                    <input type='hidden' id='hpCertDate' name='hpCertDate' value={userAuthInfo.hpCertDate} />
                    <input type='hidden' id='pswdtmp' name='pswdtmp' value={userAuthInfo.pswdtmp} />
                    <input type='hidden' id='ipinCertDate' name='ipinCertDate' />
                    <div className='flex flex-col items-center'>
                        <h2>아이디/비밀번호 찾기</h2>
                        <strong>
                            아이핀/ 휴대전화/ 가입정보 등의 본인인증 수단을 통해 아이디 및 비밀번호를 찾을 수 있습니다.
                        </strong>
                    </div>
                    <hr className='w-full'/>
                    <div className='flex flex-1 gap-6'>
                        <div className='flex flex-col gap-1'>
                            <div className='find_tab' onClick={handleTab}>
                                <Theme.InputId className={findTab === 'Id' ? 'co_dark' : 'co_light'} />
                                <div className='content-center'>
                                    <button className={`w-fit whitespace-no-wrap ${findTab === 'Id' ? '' : 'co_light'}`}>
                                        <h5>아이디 찾기</h5>
                                    </button>
                                </div>
                            </div>
                            <div className='find_tab' onClick={handleTab}>
                                <Theme.InputPw className={findTab === 'Pw' ? 'co_dark' : 'co_light'} />
                                <div className='content-center'>
                                    <button className={`w-fit whitespace-no-wrap ${findTab === 'Pw' ? '' : 'co_light'}`}>
                                        <h5>비밀번호 찾기</h5>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <hr className='h-full border-l' />
                        <div className={`w-full flex flex-col ${is17Inch ? 'gap-4': 'gap-5'}`}>
                            <div className='flex gap-2 items-center'>
                                <Icons.FaceDalgu16/>
                                <h3>{findTab === 'Id' ? '아이디 찾기' : '비밀번호 찾기'}</h3>
                            </div>
                            <div>
                                {!authenticated ? (
                                    // 본인 인증 전
                                    findTab === 'Pw' && findStep === 1 ? (
                                        <div className={`content_section w-full ${is17Inch ? 'p-6' : 'p-10'}`}>
                                            <div className='flex flex-col w-fit items-center gap-3'>
                                                <Icons.NoticeDalgu />
                                                <h4 className='co_dark'>비밀번호를 찾고자하는 아이디를 입력해주세요.</h4>
                                                <input
                                                    type='text'
                                                    name='useridno'
                                                    className='h-8'
                                                    value={upNewPw.useridno}
                                                    onChange={handleChange}
                                                    placeholder='아이디를 입력해 주세요'
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className='flex gap-8 items-center find_img_media_set'>
                                            <div className='content_section p-4'>
                                                <Icons.IconIpin/>
                                                <span>본인 명의 I-PIN계정을 통해 인증을 확인합니다.<br />타인 명의 I-PIN계정으로는 본인인증이 불가합니다.</span>
                                                <a href='#' id='btnIpin' className='auth_btn' title='새창-아이핀 인증'>아이핀 인증</a>
                                            </div>
                                            <h3 className='co_dark'>or</h3>
                                            <div className='content_section p-4'>
                                                <Icons.IconPhone />
                                                <span>본인 명의의 휴대전화를 통해 본인 인증을<br />진행하실 경우 아래 버튼을 클릭하여 주십시요.</span>
                                                <a href='#' id='btnNice' className='auth_btn' title='새창-휴대전화 인증' onClick={handleNiceAuth}>휴대전화 인증</a>
                                            </div>
                                        </div>
                                    )
                                ) : (
                                    // 본인 인증 후
                                    findTab === 'Id' ? (
                                        // 아이디 찾기 결과
                                        <div className='content_section w-full p-10' id='divSucc'>
                                            {userAuthInfo.userId !== '' ? (
                                                <>
                                                    <Icons.OkDalgu/>
                                                    <h3 className='co_dark'>귀하의 등록된 아이디는 다음과 같습니다.</h3>
                                                    <h4>{userAuthInfo.userId}</h4>
                                                </>
                                            ) : (
                                                <>
                                                    <Icons.EmptyDalgu/>
                                                    <h3 className='co_dark'>가입 이력이 존재하지 않습니다.</h3>
                                                    <h5 className='co_gray text-center'>
                                                        서비스 이용을 위해 회원가입을 진행해주시기 바랍니다.
                                                    </h5>
                                                </>
                                            )}
                                        </div>
                                    ) : (
                                        // 비밀번호 찾기 결과
                                        upNewPw.useridno === userAuthInfo.userId ? (
                                            findStep === 3 ? (
                                                <div className={`content_section w-full ${is17Inch ? 'p-4' : 'p-10'}`}>
                                                    <div className='flex flex-col w-fit items-center gap-3'>
                                                        <div className='low_none_media_set'><Icons.PwDalgu /></div>
                                                        <h3>새로운 비밀번호를 설정해 주세요.</h3>
                                                        <p className='co_dark text-center'>영문, 숫자, 특수문자 중 2종류 이상 조합 최소 10자리<br />또는 3종류 이상 조합 최소 9자리</p>
                                                        <hr className='w-full'/>
                                                        <div className='pw_box'>
                                                            <div className='pw_input_box'>
                                                                <div className='flex justify-between'>
                                                                    <p className='ml-1'>신규 비밀번호 입력</p>
                                                                    <div className={`flex items-center ${upNewPw.newpswd.length > 0 && !newpswdValid ? 'visible' : 'invisible'}`}>
                                                                        <Icons.NoticeIco16 />
                                                                        <p className='co_red'>상단의 비밀번호 조건을 확인해 주세요.</p>
                                                                    </div>
                                                                </div>
                                                                <div className={`pw_input ${upNewPw.newpswd.length > 0 && !newpswdValid ? 'pw_input_notice' : upNewPw.newpswd.length < 1 ? '' : 'pw_input_ok'}`}>
                                                                    <input className='outline_none' type={newPwOn ? 'text' : 'password'} maxLength={20} name='newpswd' value={upNewPw.newpswd} onChange={handleChange} placeholder='변경할 비밀번호를 입력해 주세요' />
                                                                    <button className='cursor-pointer' onClick={() => setNewPwOn(!newPwOn)} aria-label={newPwOn ? '비밀번호 숨기기' : '비밀번호 표시'}>
                                                                        {newPwOn ? <Icons.PwEyeOn /> : <Icons.PwEyeNon />}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className='pw_input_box'>
                                                                <div className='flex justify-between'>
                                                                    <p className='ml-1'>신규 비밀번호 재입력</p>
                                                                    <div className={`flex items-center ${upNewPw.renewpswd.length > 0 && !sameNewpswd ? 'visible' : 'invisible'}`}>
                                                                        <Icons.NoticeIco16 />
                                                                        <p className='co_red'>신규 비밀번호와 일치하지 않습니다.</p>
                                                                    </div>
                                                                </div>
                                                                <div className={`pw_input ${upNewPw.renewpswd.length > 0 && !sameNewpswd ? 'pw_input_notice' : upNewPw.renewpswd.length < 1 ? '' : 'pw_input_ok'}`}>
                                                                    <input className='outline_none' type={reNewPwOn ? 'text' : 'password'} maxLength={20} name='renewpswd' value={upNewPw.renewpswd} onChange={handleChange} placeholder='비밀번호를 재입력해 주세요' />
                                                                    <button className='cursor-pointer' onClick={() => setReNewPwOn(!reNewPwOn)} aria-label={reNewPwOn ? '비밀번호 숨기기' : '비밀번호 표시'}>
                                                                        {reNewPwOn ? <Icons.PwEyeOn /> : <Icons.PwEyeNon />}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className='content_section w-full p-10'>
                                                    <Icons.OkDalgu />
                                                    <h3 className='co_dark'>비밀번호가 정상적으로 변경되었습니다.</h3>
                                                    <p className='co_dark'>서비스 이용을 위해 로그인해 주시기 바랍니다.</p>
                                                </div>
                                            )
                                        ) : (
                                            <div className='content_section w-full p-10'>
                                                <Icons.EmptyDalgu/>
                                                <h5 className='co_dark text-center'>
                                                    본인 인증 내역과 아이디가 일치하지 않습니다.<br/>
                                                    아이디를 분실하신 경우 '아이디 찾기'를 먼저 진행해주시기 바랍니다.
                                                </h5>
                                            </div>
                                        )
                                    )
                                )}
                            </div>
                            <hr/>
                            <div className='comm_btn_box h-12'>
                                <button className='comm_btn_w w-40' onClick={handleCancel} id='btnCancel' title='뒤로'>뒤로</button>
                                {(findTab === 'Pw' && (findStep === 1 || findStep === 3)) ?
                                    <button
                                        className={`comm_btn w-40 ${findStep === 3 && isValidCheckN ? 'bg_co_gray' : 'bg_co_black'}`}
                                        onClick={findStep === 1 ? handleFindPw : findStep === 3 && isValidCheckN ? ()=>'' : passwordReset}
                                        id='btnNext'
                                        title='다음'>다음
                                    </button>
                                : authenticated ?
                                    <button className='comm_btn bg_co_black w-40' onClick={handleLogin} id='btnLogin' title='로그인'>로그인</button>
                                : ''}
                                {(findTab === 'Pw' && authenticated && upNewPw.useridno !== userAuthInfo?.userId) &&
                                    <button className='comm_btn bg_tr_primary w-40' onClick={handleTab} id='btnIdPw' title='아이디 찾기'>아이디 찾기</button>}
                                {(findTab === 'Id' && authenticated && userAuthInfo.userId === '') &&
                                    <button className='comm_btn bg_tr_primary w-40' onClick={handleJoin} id='btnJoin' title='회원가입'>회원가입</button>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FindPage;